import { get, values } from 'lodash'

export const getVenues = state => values(get(state, ['venues', 'byId']))

export const getCurrentVenueUuid = state => get(state, ['venues', 'selectedId'])

export const getIsLoadingVenues = state => state.venues.isLoading ?? false

export const getAllVenuesEnabled = state => state.venues.allVenues ?? false

export const getCurrentVenue = state =>
  get(state, ['venues', 'byId', getCurrentVenueUuid(state)], {})

export const getCurrentVenueTimezone = state => {
  const currentVenue = getCurrentVenue(state)
  const currentVenueTimezone = currentVenue?.timeZone

  return currentVenueTimezone
}
